import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-beam-sweat': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M440 160c-29.5 0-53.3-26.3-53.3-58.7 0-25 31.7-75.5 46.2-97.3 3.5-5.3 10.6-5.3 14.2 0 14.5 21.8 46.2 72.3 46.2 97.3 0 32.4-23.8 58.7-53.3 58.7zM248 400c-51.9 0-115.3-32.9-123.3-80-1.7-10 7.9-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1c10-3.2 19.4 5.4 17.7 15.3-8 47.1-71.4 80-123.3 80zM378.3 231.7c-3.1 0.9-7.2-0.1-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3zM483.6 178.8c8 24.3 12.4 50.2 12.4 77.2 0 137-111 248-248 248s-248-111-248-248 111-248 248-248c45.7 0 88.4 12.6 125.2 34.2-10.9 21.6-15.5 36.2-17.2 45.7-31.2-20.1-68.2-31.9-108-31.9-110.3 0-200 89.7-200 200s89.7 200 200 200 200-89.7 200-200c0-22.5-3.9-44.1-10.8-64.3 0.4 0 21.8 2.8 46.4-12.9zM168 189.4c-12.3 0-23.8 7.8-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-beam-sweat.js
// module id = 1751
// module chunks = 0